import {NgModule} from '@angular/core';

import {ApptextRepository} from './repositories/apptext.repository';
import {ApptextService} from './services/apptext.service';

@NgModule({
    providers: [
        ApptextRepository,
        ApptextService,
    ],
})
export class ApptextModule { }
